import * as React from 'react'
import { Article, Variation } from '../../articlesContainer'
import InstantArticlesModal from './InstantArticlesModal'

export interface InstantArticle {
	articles: {
		[uid: string]: Article
	}
	logo?: string
	logo_id?: string
	client_name?: string
}

interface InstantArticlesModalContainerProps {
	instantArticles: InstantArticle
	updateVariationField: (
		artUid: string,
		variationNum: number,
		field: keyof Variation,
		content: string,
		instant?: boolean,
	) => void
	duplicateVariation: (articleId: string, variationNo: number, instant?: boolean) => void
	removeVariation: (articleId: string, variationNo: number, instant?: boolean) => void
	addVariation: (articleId: string, instant?: boolean) => void
	updateArticle: (art: Article, instant?: boolean) => void
	addArticle: (arr: Article, instant?: boolean) => void
	client?: {
		id: number
		org: string
	}
	updateInstantArticlesProperties: (values: { logo?: string; logo_id?: string; client_name?: string }) => void
	setInstantArticlesModal: (value: boolean) => void
	instantArticlesModal: boolean
	activeInstantArticle: string
	showVariations?: () => void
}

const InstantArticlesModalContainer: React.FunctionComponent<InstantArticlesModalContainerProps> = (props) => {
	const hideInstantArticlesModal = () => {
		props.setInstantArticlesModal(false)

		const article = currentArticle()
		if (article) {
			createFirstVariationBasedOnArticle(article)
		}
		if (props.showVariations) {
			props.showVariations()
		}
	}

	const createFirstVariationBasedOnArticle = (article: Article) => {
		const variation = article.variations && article.variations[0]
		const instantArticle = article.instantArticle
		if (
			variation &&
			variation.image === '' &&
			variation.description === '' &&
			variation.title === '' &&
			instantArticle
		) {
			props.updateVariationField(article.uid, variation.variation_no, 'image', instantArticle.image, true)
			if (instantArticle.image_id) {
				props.updateVariationField(
					article.uid,
					variation.variation_no,
					'image_id',
					instantArticle.image_id,
					true,
				)
			}
			props.updateVariationField(
				article.uid,
				variation.variation_no,
				'description',
				instantArticle.introduction,
				true,
			)
			props.updateVariationField(article.uid, variation.variation_no, 'title', instantArticle.headline, true)
			props.updateVariationField(
				article.uid,
				variation.variation_no,
				'advertiser_name',
				props.client ? props.client.org : '',
				true,
			)
		}
	}

	const updateInstantArticle = (values: { [property: string]: string }) => {
		const article = currentArticle()

		if (article) {
			props.updateArticle(
				{
					...article,
					instantArticle: {
						...article.instantArticle!,
						...values,
					},
				},
				true,
			)
		}
	}

	const currentArticle = () => {
		return props.instantArticles.articles && props.instantArticles.articles[props.activeInstantArticle]
	}

	return (
		<>
			{currentArticle() && Object.keys(props.instantArticles.articles).length > 0 && (
				<InstantArticlesModal
					article={currentArticle()}
					instantArticles={props.instantArticles}
					show={props.instantArticlesModal}
					onHide={hideInstantArticlesModal}
					updateInstantArticle={updateInstantArticle}
					updateInstantArticlesProperties={props.updateInstantArticlesProperties}
					client={props.client}
				/>
			)}
		</>
	)
}
export default InstantArticlesModalContainer
